<template>
    <page>
        <module title="订单服务评价详情">
            <div v-if="evaluateInfo">
                <c-detail title="基础信息">
                    <c-detail-item label="订单号">{{evaluateInfo.order_number}}</c-detail-item>

                    <c-detail-item label="评价时间">{{evaluateInfo.pj_date}}</c-detail-item>

                    <c-detail-item label="评价用户">{{evaluateInfo.nick_name}}</c-detail-item>

                    <c-detail-item label="用户手机号">{{evaluateInfo.user_manage_mobilephone}}</c-detail-item>

                    <c-detail-item label="查看数量">{{evaluateInfo.view_count}}</c-detail-item>

                    <c-detail-item label="点赞数量">{{evaluateInfo.thumb_count}}</c-detail-item>

                    <c-detail-item label="评分">{{evaluateInfo.score}}</c-detail-item>

                    <c-detail-item label="服务名称">{{evaluateInfo.product_name}}</c-detail-item>

                    <c-detail-item label="评价内容" full>{{evaluateInfo.evaluate_comment}}</c-detail-item>

                </c-detail>

                <c-detail title="评价图片信息" v-if="imageList && imageList.length > 0">
                    <c-detail-item label="评价图片" full>
                        <div  class="flex-center-cross">
                            <c-image  v-for="(item, i) in imageList" :src="item.file_url" preview size="60" style="margin-right: 10px;"></c-image>
                        </div>
                    </c-detail-item>
                </c-detail>

                <c-detail title="评价视频信息" v-if="videoList && videoList.length > 0">
                    <c-detail-item label="评价视频" full>
                        <div  class="flex-center-cross">
                            <c-image  v-for="(item, i) in videoList" :src="item.file_url" preview size="60" style="margin-right: 10px;"></c-image>
                        </div>
                    </c-detail-item>
                </c-detail>

                <c-detail title="评价标签信息">
                    <c-detail-item  label="标签信息" full>
                        {{evaluateInfo.tag_name}}
                    </c-detail-item>
                </c-detail>
            </div>
        </module>
    </page>
</template>

<script>
    import productInfo from '@/components/public/product_info.vue'
    import {mapState} from 'vuex'

    export default {
        name: 'order_evaluate_detail',

        props: {
            id: String
        },

        components: {
            productInfo
        },

        data() {
            return {
                evaluateInfo: '',
                imageList: [],
                videoList: []
            }
        },

        computed: {
            ...mapState(['dict'])
        },

        watch: {
            id() {
                this.getEvaluateDetail();
            }
        },

        mounted() {
            this.getEvaluateDetail();
        },

        methods: {
            getEvaluateDetail() {
                this.request({
                    url: '/orderEvaluate/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.evaluateInfo = data;
                        this.imageList = data.image_list;
                        this.videoList = data.video_list;
                    }
                });
            }
        }
    }
</script>
